(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["fvr-support"] && !Shopify.designMode) return;
  try {
    
(()=>{function init(){
const root=document.getElementById('fvr-support');if(!root||root.dataset.supportInit)return;root.dataset.supportInit='1';
let products=[];try{products=JSON.parse(root.querySelector('#fvr-support-data').textContent)}catch{return;}
const tabs=[...root.querySelectorAll('[data-support]')],panel=root.querySelector('#support-panel');
function select(category,animate=true){const p=products.find(p=>p.category===category);if(!p)return;tabs.forEach(t=>{const active=t.dataset.support===category;t.setAttribute('aria-selected',String(active));t.tabIndex=active?0:-1;});panel.setAttribute('aria-labelledby','tab-'+category);const image=panel.querySelector('img');image.src=p.image;image.alt='Fivali '+p.code+' '+p.name;panel.querySelector('.eyebrow').textContent=p.detail_label;panel.querySelector('h3').replaceChildren(document.createTextNode(p.code),document.createElement('br'),document.createTextNode(p.name));panel.querySelector('.intro').textContent=p.copy;const features=panel.querySelector('.features');features.replaceChildren();p.features.filter(Boolean).forEach(text=>{const tag=document.createElement('span');tag.textContent=text;features.append(tag);});const button=panel.querySelector('.button');button.href=p.product_url;button.textContent=p.cta;const collection=panel.querySelector('.textlink');collection.href=p.collection_url;collection.textContent=p.collection_cta;if(animate&&!matchMedia('(prefers-reduced-motion: reduce)').matches)panel.animate([{opacity:.4},{opacity:1}],{duration:230,easing:'ease-out'});}
tabs.forEach((tab,i)=>{tab.addEventListener('click',()=>select(tab.dataset.support));tab.addEventListener('keydown',e=>{let n;if(e.key==='ArrowRight')n=(i+1)%tabs.length;else if(e.key==='ArrowLeft')n=(i-1+tabs.length)%tabs.length;else if(e.key==='Home')n=0;else if(e.key==='End')n=tabs.length-1;else return;e.preventDefault();tabs[n].focus({preventScroll:true});select(tabs[n].dataset.support);tabs[n].scrollIntoView({block:'nearest',inline:'nearest',behavior:'smooth'});});});
root.addEventListener('fvr:select',e=>select(e.detail));select(products[0]?.category,false);
}init();document.addEventListener('shopify:section:load',init);})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fvr-videos"] && !Shopify.designMode) return;
  try {
    

(()=>{function parseVideo(input) {
  let value = input.trim();
  if (!value) return null;
  if (value.startsWith('<')) {
    const doc = new DOMParser().parseFromString(value,'text/html');
    value = doc.querySelector('iframe')?.getAttribute('src') || doc.querySelector('blockquote[data-instgrm-permalink]')?.getAttribute('data-instgrm-permalink') || '';
    if (!value) throw new Error('请粘贴视频链接、iframe代码或Instagram官方嵌入代码。');
  }
  let u;
  try { u = new URL(value); } catch { throw new Error('请输入完整的 https 视频链接。'); }
  if (u.protocol !== 'https:') throw new Error('仅支持 https 视频链接。');
  const host = u.hostname.toLowerCase().replace(/^www\./,'');
  if (['youtube.com','m.youtube.com','youtu.be','youtube-nocookie.com'].includes(host)) {
    const id = host === 'youtu.be' ? u.pathname.split('/')[1] : (u.searchParams.get('v') || u.pathname.match(/^\/(?:embed|shorts|live)\/([^/]+)/)?.[1]);
    if (!id || !/^[A-Za-z0-9_-]{11}$/.test(id)) throw new Error('请使用YouTube视频、Shorts或官方iframe链接。');
    return {platform:'YouTube',src:'https://www.youtube-nocookie.com/embed/'+id+'?autoplay=0&playsinline=1&rel=0',original:'https://www.youtube.com/watch?v='+id};
  }
  if (['instagram.com','m.instagram.com'].includes(host)) {
    const match = u.pathname.match(/^\/(p|reel|reels|tv)\/([A-Za-z0-9_-]+)/);
    if (!match) throw new Error('请使用具体Instagram帖子或Reel链接。');
    const kind = match[1] === 'reels' ? 'reel' : match[1];
    const original = 'https://www.instagram.com/'+kind+'/'+match[2]+'/';
    return {platform:'Instagram',src:original+'embed/',original};
  }
  if (['facebook.com','m.facebook.com','web.facebook.com'].includes(host)) {
    if (u.pathname === '/plugins/video.php') {
      const nested = u.searchParams.get('href');
      if (!nested) throw new Error('Facebook iframe中缺少视频地址。');
      return parseVideo(nested);
    }
    if (!u.pathname.includes('/videos/') && !/^\/reel\/\d+/.test(u.pathname) && !(/^\/watch\/?$/.test(u.pathname) && /^\d+$/.test(u.searchParams.get('v')||''))) throw new Error('请使用Facebook完整视频或Reel地址，先展开share或fb.watch短链接。');
    u.hostname = 'www.facebook.com';u.hash='';
    const original = u.toString();
    return {platform:'Facebook',src:'https://www.facebook.com/plugins/video.php?href='+encodeURIComponent(original)+'&show_text=false&width=500',original};
  }
  throw new Error('支持YouTube、Instagram、Facebook。短链接请先展开为完整视频地址。');
}

function validDestination(value) {
  if (!value) return '';
  if(typeof value!=='string')return '';
  value=value.trim();
  if((value.startsWith('/')&&!value.startsWith('//'))||value.startsWith('#'))return value;
  try {const url=new URL(value,location.href);return ['https:','http:'].includes(url.protocol)?value:'';} catch {return '';}
}
function productDestination(category) {
  try {const products=JSON.parse(document.getElementById('fvr-support-data')?.textContent||'[]');return validDestination(products.find(p=>p.category===category)?.product_url)||'#categories';} catch {return '#categories';}
}
function makeFrame(video,title,preview) {
  const frame=document.createElement('iframe');
  frame.src=video.src;frame.title=title+' · '+video.platform;
  frame.allow='autoplay; encrypted-media; picture-in-picture; fullscreen';frame.allowFullscreen=true;
  frame.referrerPolicy='strict-origin-when-cross-origin';
  if(preview){frame.loading='lazy';frame.className='fvr-video-preview';frame.tabIndex=-1;frame.setAttribute('aria-hidden','true');}
  return frame;
}
function installDefaultCover(visual,video,item) {
  if(item.image||visual.querySelector('img'))return;
  visual.querySelector('.slot-number')?.remove();
  if(video.platform==='YouTube') {
    const id=new URL(video.src).pathname.split('/').pop();
    const image=document.createElement('img');image.className='fvr-auto-cover';image.alt=item.title||'Video cover';image.loading='lazy';image.width=900;image.height=1300;
    let fallback=false;
    const useFallback=()=>{if(fallback)return;fallback=true;image.src='https://i.ytimg.com/vi/'+id+'/hqdefault.jpg';};
    image.addEventListener('error',useFallback);
    image.addEventListener('load',()=>{if(!fallback&&image.naturalWidth<=120){useFallback();return;}visual.classList.remove('empty-video');});
    image.src='https://i.ytimg.com/vi/'+id+'/maxresdefault.jpg';visual.prepend(image);
  } else {
    visual.prepend(makeFrame(video,item.title||'Video preview',true));visual.classList.remove('empty-video');
  }
}
function init(){
 const root=document.getElementById('fvr-videos');if(!root||root.dataset.videoInit)return;
 const grid=root.querySelector('.storygrid');let data=[];try{data=JSON.parse(root.querySelector('#fvr-video-data').textContent)}catch{return;}
 root.dataset.videoInit='1';
 [...grid.querySelectorAll('.story')].forEach((card,i)=>{
  const item=data[i];if(!item)return;let video=null;try{video=parseVideo(item.url||'')}catch{}
  const play=card.querySelector('.play'),tag=card.querySelector('.storytag'),link=card.querySelector('.storyfoot>a'),visual=card.querySelector('.storyvisual');
  link.href=validDestination(item.destination)||productDestination(item.category||'back');link.removeAttribute('target');link.removeAttribute('rel');link.setAttribute('aria-label','Explore '+(item.product||item.subtitle||'support'));
  if(video){
   tag.textContent=video.platform;play.disabled=false;installDefaultCover(visual,video,item);
   play.addEventListener('click',()=>{visual.replaceChildren();visual.classList.add('playing');visual.append(makeFrame(video,item.title||'Video',false));});
  }else{tag.textContent='SCENE PREVIEW';play.disabled=true;play.setAttribute('aria-label','Video coming soon');}
 });
}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();
document.addEventListener('shopify:section:load',init);
})();


  } catch(e) { console.error(e); }
})();
})();
